<template>
  <div class="text-justify flex">
    <main-container :isPage="true">
      <h1 class="text-center">{{ $t("privacyPolicy.title") }}</h1>
      <hr class="primary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.paragraph')"
        v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
        :key="`privacyPolicyParagraph-${i}`"
      />

      <h2>{{ $t("privacyPolicy.dataTreatment.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.dataTreatment.paragraph')"
        v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
        :key="`privacyPolicyDataTreatmentParagraph-${i}`"
      />

      <h2>{{ $t("privacyPolicy.dataCollected.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.dataCollected.paragraph')"
        :key="`privacyPolicyDataCollectedParagraph-${i}`"
      >
        {{ paragraph }}
      </p>
      <ul>
        <li
          v-for="(list, i) in $t('privacyPolicy.dataCollected.list')"
          :key="`privacyPolicyDataCollectedList-${i}`"
        >
          {{ list }}
        </li>
      </ul>

      <h2>{{ $t("privacyPolicy.dataObjective.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.dataObjective.paragraph')"
        :key="`privacyPolicyDataObjectiveParagraph-${i}`"
      >
        {{ paragraph }}
      </p>
      <ul>
        <li
          v-for="(list, i) in $t('privacyPolicy.dataObjective.list')"
          :key="`privacyPolicyDataObjectiveList-${i}`"
        >
          {{ list.description }}
          <ul>
            <li v-for="(list2, j) in list.list" :key="`privacyPolicyDataObjectiveList-${i}-${j}`">
              {{ list2 }}
            </li>
          </ul>
        </li>
      </ul>

      <h2>{{ $t("privacyPolicy.dataUsage.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.dataUsage.paragraph')"
        :key="`privacyPolicyDataUsageParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("privacyPolicy.dataMedia.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.dataMedia.paragraph')"
        v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
        :key="`privacyPolicyDataMediaParagraph-${i}`"
      />
      <ul>
        <li
          v-for="(list, i) in $t('privacyPolicy.dataMedia.list')"
          :key="`privacyPolicyDataMediadList-${i}`"
        >
          {{ list }}
        </li>
      </ul>

      <h2>{{ $t("privacyPolicy.dataTransfer.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.dataTransfer.paragraph')"
        :key="`privacyPolicyDataTransferParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("privacyPolicy.webBeacons.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.webBeacons.paragraph')"
        :key="`privacyPolicyWebBeaconsParagraph-${i}`"
      >
        {{ paragraph }}
      </p>

      <h2>{{ $t("privacyPolicy.updates.title") }}</h2>
      <hr class="secondary" />
      <p
        v-for="(paragraph, i) in $t('privacyPolicy.updates.paragraph')"
        :key="`privacyPolicyUpdatesParagraph-${i}`"
      >
        {{ paragraph }}
      </p>
    </main-container>
  </div>
</template>

<script>
const MainContainer = () =>
  import(/* webpackChunkName: "MainContainerComponent" */ "@/components/Global/MainContainer.vue");

export default {
  name: "PrivacyPolicy",
  components: {
    MainContainer
  }
};
</script>
